export var AsideModes;
(function (AsideModes) {
    AsideModes["default"] = "default";
    AsideModes["create"] = "create";
})(AsideModes || (AsideModes = {}));
